import React, { FC } from "react";
import classes from "./SelectProductItemsMain.module.scss";
import ProductionDepartment from "./department/ProductionDepartment";

import { Box } from "@mui/material";
import {
  productDepartments,
  productItems,
} from "../../../../../commons/productItems";

const SelectProductItemsMain = (props) => {
  const {
    checkedItems,
    setCheckedItems,
    checkedItemsForUi,
    setCheckedItemsForUi,
  } = props;

  return (
    <Box sx={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}>
      {productDepartments.map((department) => {
        const filteredProductItemns = productItems.filter(
          (item) => item.department === department.name
        );
        return (
          <ProductionDepartment
            key={department.id}
            departmentId={department.id}
            departmentName={department.name}
            productItems={filteredProductItemns}
            checkedItems={checkedItems}
            setCheckedItems={setCheckedItems}
            checkedItemsForUi={checkedItemsForUi}
            setCheckedItemsForUi={setCheckedItemsForUi}
          />
        );
      })}
    </Box>
  );
};

export default SelectProductItemsMain;
